<template>
  <div id="resolveTask">
    <div class="pageTitle">
      <b>批量分解任务</b>
      <a v-if="this.formData.taskList.length==0" class="newAdd1" @click="addRow">
        <i class="el-icon-plus"/> 新增
      </a>
      <hr>
    </div>
    <el-container>

      <el-main>
         <div id="tianxie"><span style="color:red">*</span> ETA： <el-date-picker
      v-model="demand_plan_submit_time"
      type="date"
      placeholder="选择日期"
      value-format="yyyy-MM-dd"
      :disabled="isETA"
      >
    </el-date-picker></div>
        <div style="text-align:center;color:#606266;padding-bottom:10px;">
          <b>相关任务</b>
        </div>
        <div class="taskStyle">
          <el-table :data="tableList" style="width: 100%">
            <el-table-column label="任务编号" prop="task_id"></el-table-column>
            <el-table-column label="任务标题">
              <template slot-scope="scope">
                <router-link
                  :to="{path:'/allTask/newCheckTask',query:{'task_id':scope.row.task_id}}"
                >{{ scope.row.task_name }}</router-link>
              </template>
            </el-table-column>
            <el-table-column prop="status_name" label="任务状态"></el-table-column>
            <el-table-column prop="task_creater_name" width="150" label="任务当前处理人"></el-table-column>
            <el-table-column prop="task_coding_user_name" width="150" label="开发"></el-table-column>
            <el-table-column prop="task_test_user_name" width="150" label="测试"></el-table-column>
          </el-table>
        </div>

        <el-form ref="formData" :model="formData" label-position="top" :inline="true" size="medium">
          <div
            v-for="(item,index) in formData.taskList"
            :key="index"
            style="position:relative;padding:15px 15px 10px 15px;margin-bottom:10px;box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 5px 1px rgba(60, 64, 67, .15);border-radius:5px;"
          >
            <div>
              <b>序号</b>
              ：{{index+1}}
              <el-button
                style="font-size:20px;color:red;"
                v-if="formData.taskList.length > 1"
                type="text"
                icon="el-icon-delete"
                @click="removeRow(index)"
              ></el-button>
            </div>
            <el-form-item
              label="是否需要测试："
              :rules="[{ required: true, message: '不能为空',trigger: 'change'}]"
              :prop="'taskList.' + index + '.task_is_test'"
            >
              <!-- <b style="margin-left:30px"> 是否需要测试：</b>  -->
              <el-radio-group v-model="item.task_is_test" size="small" float="left">
                <el-radio-button :label="1">是</el-radio-button>
                <el-radio-button :label="0">否</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="是否需要需求方验收："
              :rules="[{ required: true, message: '不能为空',trigger: 'change'}]"
              :prop="'taskList.' + index + '.is_inform'"
            >
              <el-radio-group v-model="item.is_inform" size="small">
                <el-radio-button :label="1">是</el-radio-button>
                <el-radio-button :label="0">否</el-radio-button>
              </el-radio-group>
            </el-form-item>

            <el-row>
              <el-col :span="8">
                <el-form-item :prop="'taskList.' + index + '.demand_id'" label="相关需求">
                  <el-input v-model="demand_name" placeholder="请输入" disabled>{{demand_name}}</el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                  :prop="'taskList.' + index + '.task_name'"
                  :rules="[{ required: true, message: '不能为空',trigger: 'change'},{max: 100, message: '不超过100个字符', trigger: 'blur'}]"
                  label="任务标题"
                >
                  <el-input v-model="item.task_name" placeholder="请输入" clearable>
                    <template slot="prepend">
                      <el-button
                        type="primary"
                        icon="el-icon-edit"
                        @click="likeDemand_name(index)"
                      >同需求</el-button>
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                  :prop="'taskList.' + index + '.date'"
                  :rules="[{ required: true, message: '不能为空',trigger: 'change'}]"
                  label="计划开发时间"
                >
                  <el-date-picker
                    v-model="item.date"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="4">
                <el-form-item
                  :prop="'taskList.' + index + '.task_level'"
                  :rules="[{ required: true, message: '不能为空',trigger: 'change'}]"
                  label="优先级"
                >
                  <el-select v-model="item.task_level" placeholder="请选择">
                    <el-option label="特别高" :value="3"/>
                    <el-option label="高" :value="2"/>
                    <el-option label="中" :value="1"/>
                    <el-option label="低" :value="0"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item
                  :prop="'taskList.' + index + '.task_degree_of_difficulty'"
                  :rules="[{ required: true, message: '不能为空',trigger: 'change'}]"
                  label="难度系数"
                >
                  <el-select v-model="item.task_degree_of_difficulty" placeholder="请选择">
                    <el-option label="普通" :value="1"/>
                    <el-option label="一般" :value="2"/>
                    <el-option label="中等" :value="3"/>
                    <el-option label="困难" :value="4"/>
                    <el-option label="挑战" :value="5"/>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="4">
                <el-form-item
                  :prop="'taskList.' + index + '.task_coding_user'"
                  :rules="[{ required: true, message: '不能为空',trigger: 'change'}]"
                  label="程序员"
                >
                  <el-select
                    clearable
                    v-model="item.task_coding_user"
                    :remote-method="getUserInfoByName"
                    :loading="selectLoading"
                    placeholder="请搜索"
                    filterable
                    remote
                    reserve-keyword
                    @visible-change="clearSelectList"
                  >
                    <el-option
                      v-for="user in personInChargeList"
                      :label="user.name+'('+user.username+')'+`${(user.state !== 1 || user.status !==1)?'(不可用)':''}`"
                      :value="user.userId"
                      :key="user.userId"
                    />
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="4">
                <el-form-item
                  :prop="'taskList.' + index + '.task_coding_time'"
                  :rules="[{ required: true, message: '请填写预计开发工时', trigger: 'change' }]"
                  label="预计开发工时"
                >
                  <el-input-number
                    v-model="item.task_coding_time"
                    :min="0.1"
                    :step="0.1"
                    controls-position="right"
                    @change="handleChange"
                  />
                </el-form-item>
              </el-col>

              <el-col :span="4">
                <el-form-item
                  :prop="'taskList.' + index + '.task_test_time'"
                  v-if="item.task_is_test==1 || item.is_inform == 1"
                  label="预计测试工时"
                >
                  <el-input-number
                    v-model="item.task_test_time"
                    :min="0.1"
                    :step="0.1"
                    controls-position="right"
                    @change="handleChange"
                  />
                </el-form-item>
              </el-col>

              <el-col :span="4">
                <el-form-item
                  v-if="item.task_is_test==1 || item.is_inform == 1"
                  :prop="'taskList.' + index + '.task_test_user'"
                  :rules="[{ required: true, message: '不能为空',trigger: 'change'}]"
                  label="测试人"
                >
                  <el-select
                    clearable
                    v-model="item.task_test_user"
                    :remote-method="getUserInfoByName"
                    :loading="selectLoading"
                    placeholder="请搜索"
                    filterable
                    remote
                    reserve-keyword
                    @visible-change="clearSelectList"
                  >
                    <el-option
                      v-for="user in personInChargeList"
                      :label="user.name+'('+user.username+')'+`${(user.state !== 1 || user.status !==1)?'(不可用)':''}`"
                      :value="user.userId"
                      :key="user.userId"
                    />
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="4">
                <el-form-item
                  :prop="'taskList.' + index + '.task_note'"
                  :rules="[{ required: false, message: '备注',trigger: 'blur'}]"
                  multiple
                  drag
                  label="备注"
                >
                  <el-input v-model="item.task_note" placeholder="请输入" clearable/>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="附件" :index="index">
              <el-upload
                :file-list="item.fileList"
                :action="actionUrl"
                :http-request="uploadFile"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :on-preview="downFile"
                accept="*"
                class="upload-demo"
                multiple
                @click.native="uploadBtn(index)"
              >
                <el-button size="small" icon="el-icon-upload" type="primary">上传附件</el-button>
                <!-- <div slot="tip" class="el-upload__tip">文件大小不能超过10M!</div> -->
              </el-upload>
            </el-form-item>

            <el-row>
              <el-col :span="24">
                <el-form-item
                  style="width:100%"
                  :prop="'taskList.' + index + '.task_remark'"
                  :rules="[{ required: false, message: '描述',trigger: 'blur'}]"
                  label="任务描述"
                >
                  <TipTapEditor v-model="item.task_remark" />
                  <!-- <Wangeditor v-model="item.task_remark" @change="decChange(item.task_remark,index)" /> -->
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!-- <div
              style="textAlign:center;left:50%;margin-left: -50px;margin-top: 10px;position:absolute;"
            >
              <a class="newAdd" @click="addRow(index)">
                <i class="el-icon-plus"/> 新增
              </a>
          </div>-->

          <div style="textAlign:center;margin-top:-10px;">
            <a class="newAdd" @click="addRow(index)">
              <i class="el-icon-plus"/> 新增
            </a>
          </div>
          <el-row style="text-align:center;">
            <el-button
              size="medium"
              style="width:100px;margin-right:200px;"
              type="primary"
              @click="submitForm('formData')"
              :loading="loading"
              :disabled="isShow"
            >提 交</el-button>
            <el-button @click="goBack" style="width:100px">返 回</el-button>
          </el-row>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  getUserInfoByName,
  getUserInfoByIdList
} from '@/api/login'
import {
  getEditDemand,
  getTask
} from '@/api/decompositionTask'
import Tinymce from '@/components/Tinymce'
// import Wangeditor from '@/components/Wangeditor'
import axios from 'axios'
import { uploadImg, deleteUpload } from '@/api/upload'
import { localStorageFn } from '@/utils'
export default {
  name: 'TinymceDemo',
  components: { Tinymce },

  data() {
    return {
      index: '',
      fileList: [],
      tableList: [],
      isShow: false,
      demand_id: '',
      demand_name: '',
      task_remark: '',
      demandObj: [],
      formData: {
        taskList: [
          {
            demand_id: '', // 需求id
            task_level: '', // 优先级
            task_degree_of_difficulty: '', // 难度系数
            task_coding_user: '', // 开发负责人
            task_name: '', // 任务标题
            task_remark: '', // 任务描述
            task_plan_start_date: '', // 计划开始时间
            task_plan_complete_date: '', // 计划完成时间
            task_coding_time: '', // 开发预计工时
            task_test_user: '', // 任务测试人员
            task_test_time: '', // 预计测试工时
            task_note: '', // 任务备注
            task_attachment: [], // 任务附件
            fileList: [],
            task_is_test: 1,
            is_inform: 1
          }
        ]
      },

      // 用户搜索，模糊查询
      selectLoading: false,
      loading: false,
      personInChargeList: [],
      demand_plan_submit_time: '', // 时间
      isETA: false,
      actionUrl: process.env.VUE_APP_BASE_API + '/api/common/upload'
    }
  },
  computed: {
    ...mapGetters(['size', 'userId', 'urlInfo'])
  },
  created() {
    this.demand_id = parseInt(this.$route.params.demand_id)
    const obj = {
      demand_id: this.demand_id,
      demand_name: this.demand_name
    }
    this.demandObj.push(obj)

    // 获取需求的标题和描述
    getEditDemand(this.$route.params.demand_id, this.urlInfo.systemCode).then(
      response => {
        this.demand_name = response.data.list[0].demand_name
        if (response.data.list[0].demand_plan_submit_time) {
          this.demand_plan_submit_time = response.data.list[0].demand_plan_submit_time
          this.isETA = true
        }

        // this.task_remark = response.data.list[0].demand_remark;
        // this.formData.taskList[0].task_remark =
        //   response.data.list[0].demand_remark;
      }
    )

    // 获取需求下相关任务列表
    getTask(this.$route.params.demand_id)
      .then(response => {
        if (response.data.length === 0) {
          console.log(22)
        } else {
          const useridList = []
          for (let i = 0; i < response.data.length; i++) {
              ['task_creater','task_coding_user','task_test_user'].forEach((sKey)=>{
                const sKeyValue = localStorageFn(response.data[i][sKey],2);
                if(sKeyValue){
                  response.data[i][sKey+'_name'] = sKeyValue.name
                  response.data[i][sKey+'_username'] = sKeyValue.username
                }else{
                  useridList.push(response.data[i][sKey])
                }
                console.log(999,sKey, sKeyValue);

              });
            }

            const p1 = getUserInfoByIdList({
              userIds: useridList
            }).then((res) => {
              const userData = res.data
              for (const i in response.data) {
                ['task_creater','task_coding_user','task_test_user'].forEach((sKey)=>{
                  if(!response.data[i][sKey+'_name']){
                    const tempItem = userData.find((item)=>{
                      return item.userId == response.data[i][sKey]
                    })
                    response.data[i][sKey+'_name'] = tempItem.name
                    response.data[i][sKey+'_username'] = tempItem.username
                    localStorageFn(response.data[i][sKey],1,tempItem);
                  }
              });
              }
            })
            if(useridList.length>0){
              Promise.all([p1])
              .then(() => {
                this.taskList = response.data
              })
              .catch(() => {
                this.$message({
                  message: '获取用户信息失败!',
                  type: 'error'
                })
              })
            }else{
              this.taskList = response.data
            }
        }
      })
      .catch(error => {
        console.log(error)
      })
  },

  methods: {
    addRow(index) {
      if (this.isShow) {
        this.formData.taskList.push({
          demand_id: '', // 需求id
          task_level: '', // 优先级
          task_degree_of_difficulty: '', // 难度系数
          task_coding_user: '', // 开发负责人
          task_name: '', // 任务标题
          task_remark: '', // 任务描述
          task_plan_start_date: '', // 计划开始时间
          task_plan_complete_date: '', // 计划完成时间
          task_coding_time: '', // 开发预计工时
          task_test_user: '', // 任务测试人员
          task_test_time: '', // 预计测试工时
          task_note: '', // 任务备注
          task_attachment: [], // 任务附件
          date: '', // 开始结束时间组件值数组
          task_is_test: 1,
          is_inform: 1
        })
      } else {
        this.formData.taskList.push({
          demand_id: '', // 需求id
          task_level: '', // 优先级
          task_coding_user: '', // 开发负责人
          task_name: '', // 任务标题
          // task_remark: this.formData.taskList[index].task_remark, // 任务描述同上面
          task_remark: '', // 任务描述
          task_plan_start_date: '', // 计划开始时间
          task_plan_complete_date: '', // 计划完成时间
          task_coding_time: '', // 开发预计工时
          task_test_user: '', // 任务测试人员
          task_test_time: '', // 预计测试工时
          task_note: '', // 任务备注
          task_attachment: [], // 任务附件
          fileList: [],
          date: '',
          task_is_test: 1,
          is_inform: 1
        })
      }
      this.isShow = false
    },
    // 删除属性列
    removeRow(index) {
      this.formData.taskList.splice(index, 1)
    },
    // 方法开始
    // 提交表单
    submitForm(formName) {
      if (this.demand_plan_submit_time === false) {
        this.$message({
          message: '请填写ETA时间！',
          type: 'error'
        })
        document.getElementById('tianxie').scrollIntoView()
        return false
      }

      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          const arrOne = this.formData.taskList // 太长了定义一个代替
          // for (let j = 0; j < arrOne.length-1; j++) {
          // for (let k=arrOne.length-1;k>j ; k--) {
          //       if(arrOne[k-1].task_name == arrOne[k].task_name){
          //         this.$message({
          //         message: "任务名重复，请修改后提交",
          //         type: "error"
          //       });
          //         return false;
          //       }
          //    }
          // }

          for (let i = 0; i < arrOne.length; i++) {
            arrOne[i].user_id = this.userId
            arrOne[i].demand_id = this.demand_id
            arrOne[i].task_plan_start_date = arrOne[i].date[0]
            arrOne[i].task_plan_complete_date = arrOne[i].date[1]
          }
          // console.log("arrOne",arrOne)
          const arr = JSON.parse(JSON.stringify(arrOne)) // 同一地址问题
          // console.log(11, arr);

          for (let i = 0; i < arr.length; i++) {
            delete arr[i].date // 去掉多余项
            delete arr[i].fileList // 去掉多余项
            if (arr[i].task_is_test === 0 && arr[i].is_inform === 0) {
              delete arr[i].task_test_time
              delete arr[i].task_test_user
            }
          }

          // 解决两次请求，第一次会报错第二次成功
          axios({
            method: 'post',
            url: `${process.env.VUE_APP_BASE_API}/api/version/decompose-task`,
            data: {
              tasks: arr,
              demand_plan_submit_time: this.demand_plan_submit_time
            }
          })
            .then(response => {
              let count = 0
              for (var i = 0; i < response.data.length; i++) {
                if (response.data[i].code === '200' || response.data[i].code === '400') {
                  this.loading = false
                }
                if (response.data[i].code === '200') {
                  this.$message({
                    message: '序号' + (i + 1) + '提交成功！',
                    type: 'success',
                    showClose: true,
                    duration: 5000
                  })
                  count++
                  this.formData.taskList.splice(i, 1)
                } else if (response.data[i].code === '400') {
                  this.$message({
                    message: '序号' + (i + 1) + '错误：' + response.data[i].msg,
                    type: 'error',
                    offset: 200,
                    showClose: true,
                    duration: 8000
                  })
                } else {}
              }

              if (count === response.data.length) {
                this.isShow = true
                this.$message({
                  message: '全部提交成功！',
                  type: 'success',
                  offset: 100,
                  duration: 5000
                })
                this.goBack()
              } else {
                // this.$message.error("以下表单提交有错误！");
                this.isShow = false
              }
            })
            .catch(err => {
              console.log(err)
            })
        } else {
          this.$message({
            message: '表单未填写完整',
            type: 'warning'
          })
          return false
        }
      })
    },
    // 返回上一页
    goBack() {
      this.$router.go(-1)
      // console.log(this.formData.taskList);
    },
    // 计数框
    handleChange(val) {
      console.log(val)
    },
    // 搜索人
    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants

      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        cb(results)
      }, 3000 * Math.random())
    },
    createStateFilter(queryString) {
      return state => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        )
      }
    },
    handleSelect(item) {
      // console.log(item);
    },
    // 搜索用户
    getUserInfoByName(query) {
      if (query !== '') {
        this.selectLoading = true
        const params = {
          name: query,
          pageNum: 1,
          pageSize: 10
        }
        getUserInfoByName(params).then(res => {
          this.personInChargeList = res.data.list
          this.selectLoading = false
        })
      }
    },
    // 选中之后清空用户list
    clearSelectList(val) {
      if (val === false) {
        this.personInChargeList = []
      }
    },
    likeDemand_name(index) {
      this.formData.taskList[index].task_name = this.demand_name
    },
    // 成功消息提示
    successMsg() {
      this.$message({
        message: '成功',
        type: 'success',
        duration: 4000
      })
    },
    // 上传的方法
    uploadBtn(index) {
      this.index = parseInt(index)
    },
    uploadFile(params) {
      const _file = params.file
      const isLt2M = _file.size / 1024 / 1024 < 10

      if (!isLt2M) {
        this.$message({
          type: 'warning',
          message: '请上传10M以下的文件'
        })
        return false
      }

      // 发起请求
      uploadImg(params).then(res => {
        if (res.code === '200') {
          this.formData.taskList[this.index].task_attachment.push(res.data)
          //  this.formData.taskList[this.index].fileList.push(res.data);
          const addFileShow = {
            name: res.data,
            url: res.data
          }
          this.formData.taskList[this.index].fileList.push(addFileShow)
          this.$message({
            type: 'success',
            message: '上传成功'
          })
        } else {
          this.$message.error('上传失败')
        }
      })
    },

    handleRemove(file, fileList) {
      for (const i of this.formData.taskList[this.index].fileList) {
        if (file.name === i.name) {
          const params = {
            file_path: i.url
          }
          deleteUpload(params).then(res => {})
          this.formData.taskList[this.index].task_attachment.splice(i, 1)
          this.formData.taskList[this.index].fileList.splice(i, 1)
        }
      }
    },
    downFile(file) {
      console.log('下载的', file)
      this.$confirm('是否要要下载该文件?', '提示', {
        confirmButtonText: '下载',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const formData = { file_path: file.url }
          axios({
            method: 'post',
            url: `${process.env.VUE_APP_BASE_API}/api/common/download-upload`,
            responseType: 'blob',
            data: formData
          })
            .then(res => {
              const blobUrl = window.URL.createObjectURL(res.data)
              download(blobUrl)
              function download(blobUrl) {
                const a = document.createElement('a')
                a.style.display = 'none'
                a.download = file.url
                a.href = blobUrl
                a.click()
                document.body.removeChild(a)
              }
            })
            .catch(() => {
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消下载'
          })
        })
    },

    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      )
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    // 上传的结束
    decChange(val, index) {
      this.taskList[index].task_remark = val
    }
  }
}
</script>

<style scoped>
.newAdd {
  display: inline-block;
  width: 100px;
  height: 30px;
  line-height: 30px;
  background-color: #67c23a;
  text-align: center;
  color: #fff;
  border-radius: 0 0 10px 10px;
}
.newAdd1 {
  display: inline-block;
  width: 100px;
  height: 30px;
  line-height: 30px;
  background-color: #67c23a;
  text-align: center;
  color: #fff;
  margin-left: 20px;
  border-radius: 2px;
}

.el-form .el-col .el-form-item {
  width: 99%;
}
.el-form .el-col .el-select {
  width: 100%;
}
.el-form .el-col .el-input-number--medium {
  width: 100%;
}
.el-form .el-col .el-range-editor--medium.el-input__inner {
  width: 100%;
}
.el-form .el-form-item {
  margin: 0 2px 0 0;
}
.el-container {
  padding: 5px 50px 10px 30px;
}
.taskStyle {
  margin: 0 auto;
  margin-bottom: 5px;
  box-shadow: 0 4px 8px 0 rgba(7, 17, 27, 0.1);
  border-radius: 5px;
}
.el-main {
  padding-top: 0;
}
.el-header {
  height: 0px;
}
.pageTitle {
  padding: 10px 40px 0px 40px;
}
</style>
<style>
/* #resolveTask .el-upload-list {
  border: 1px solid #ccc;
  width: 100%;
  height: 40px;
  float: right;
  top: -5px;
  left: 110px;
  border-radius: 5px;
  position: absolute;
  overflow: auto;
}
#resolveTask .el-upload-list li {
  border: 1px solid #ccc;
  float: left;
  margin: 5px 0 0 10px;
  width: 180px;
} */
#resolveTask .el-form--label-top .el-form-item__label {
  padding: 0;
}
</style>

